import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    accounts: null,
    gatewayId: null,
    userId: null,
    userName: null,
    userRoleName: null,
    token: null,
    results: null,
    pagination: null,
    roles: null,
    businessUnits: null
  },
  mutations: {
    AUTH_USER(state, authData) {
      state.accounts = authData.accounts;
      state.gatewayId = authData.gatewayId;
      state.userId = authData.userId;
      state.userName = authData.userName;
      state.token = authData.token;
    },
    SET_USER_ROLE_NAME(state, payload) {
      state.userRoleName = payload;
    },
    LOGOUT_USER(state) {
      state.accounts = null;
      state.gatewayId = null;
      state.userId = null;
      state.userName = null;
      state.userRoleName = null;
      state.token = null;
    },
    SET_USERS(state, payload) {
      state.results = payload.results;
      state.pagination = payload.pagination;
    },
    SET_ROLES(state, payload) {
      state.roles = payload;
    },
    SET_BUSINESS_UNITS(state, payload) {
      state.businessUnits = payload;
    }
  },
  actions: {
    authUser({ commit }, authData) {
      try {
        commit("AUTH_USER", authData);

        const roleName = authData.accounts.find(account => account.selected)
          .roleName;
        commit("SET_USER_ROLE_NAME", roleName);
        //console.log("userStore: user data stored");
      } catch (error) {
        throw error;
      }
    },
    logoutUser({ commit }) {
      try {
        commit("LOGOUT_USER");
      } catch (error) {
        throw error;
      }
    },
    async load({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get("/admin/users", {
          params
        });
        res.data.results.forEach(element => {
          element.password = "******";
        });
        commit("SET_USERS", res.data);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async save({ commit }, params) {
      /*
      return await Vue.prototype.$axios.put(`/admin/users/${params.id}`, {
        name: params.name,
        email: params.email,
        roleId: params.roleId
      });
      */

      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.put(
          `/admin/users/${params.id}`,
          {
            name: params.name,
            email: params.email,
            roleId: params.roleId,
            ERPCode: params.ERPCode,
            locationERPCode: params.locationERPCode,
            businessUnitId: params.businessUnitId
          }
        );
        if (res.status != 200) {
          const error = new Error();
          if (res.data && res.data.message) error.message = res.data.message;
          error.response = res;
          throw error;
        }
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async add({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.post("/admin/users", {
          name: params.name,
          email: params.email,
          password: params.password,
          roleId: params.roleId,
          ERPCode: params.ERPCode,
          locationERPCode: params.locationERPCode,
          businessUnitId: params.businessUnitId
        });
        if (res.status != 201) {
          const error = new Error();
          if (res.data && res.data.message) error.message = res.data.message;
          error.response = res;
          throw error;
        }
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async delete({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.delete(`/admin/users/${id}`);
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async loadRoles({ commit }) {
      try {
        let res = await Vue.prototype.$axios.get("/admin/roles");
        commit("SET_ROLES", res.data);
        return res.data;
      } catch (err) {
        throw err;
      }
    },
    async loadBusinessUnits({ commit }) {
      try {
        let res = await Vue.prototype.$axios.get(
          "/admin/business-units?pageSize=1000&orderBy=name"
        );
        commit("SET_BUSINESS_UNITS", res.data.results);
        return res.data.results;
      } catch (err) {
        throw err;
      }
    }
  },
  getters: {
    user: state => {
      return {
        accounts: state.accounts,
        gatewayId: state.gatewayId,
        userId: state.userId,
        userName: state.userName,
        userRoleName: state.userRoleName,
        token: state.token
      };
    }
  }
};
